import React from 'react'
import StatusApplication from './StatusApplication'
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const AllRenewApplications = () => {
  
  const editApplicationPermission = checkPermission(
    permissionsConfig.editRenewTotalApplications.role,
    permissionsConfig.editRenewTotalApplications.action,
    permissionsConfig.editRenewTotalApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteRenewTotalApplications.role,
    permissionsConfig.deleteRenewTotalApplications.action,
    permissionsConfig.deleteRenewTotalApplications.type
  );
  
  return (
    <StatusApplication appStatus="" title="All" subTitle="All" application_type="1" pageFrom="renew/all" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
}

export default AllRenewApplications